import lazyLoading from '../../utils/lazyLoading'

export default {
  hidden: true,
  createroutes: true,
  name: 'province',
  meta: {
    label: 'PROVINCIE',
    permission: 'ADSV',
    icon: 'mdi-drag-variant',
    expanded: false
  },
  children: [
    {
      name: 'province_series',
      path: '/province/:province_id/series/',
      props: true,
      meta: {
        label: 'Reeksen',
        icon: 'mdi-security',
        permission: 'COSEV'
      },
      component: lazyLoading('province/Series')
    },
    {
      name: 'province_teams',
      path: '/province/:province_id/teams/',
      props: true,
      meta: {
        label: 'Ploegen',
        icon: 'mdi-security',
        permission: 'COTEV'
      },
      component: lazyLoading('province/Teams')
    },
    {
      name: 'province_matches',
      path: '/province/:province_id/matches/',
      props: true,
      meta: {
        label: 'Wedstrijden',
        icon: 'mdi-security',
        permission: 'COMAV'
      },
      component: lazyLoading('province/Matches')
    },
    {
      name: 'province_sporthalls',
      path: '/province/:province_id/sporthalls/',
      props: true,
      meta: {
        label: 'Sporthallen',
        icon: 'mdi-security',
        permission: 'COSPV'
      },
      component: lazyLoading('province/Sporthalls')
    }
  ]
  /* ,
  {
    name: 'Leden',
    path: '/admin/members',
    meta: {
      permission: '*',
      link: 'admin/Members.vue'
    },
    component: lazyLoading('admin/Members')
  } */
}



// WEBPACK FOOTER //
// ./src/store/menu/province.js